import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { services } from "@/mocks/home";

export default function Services() {
  return (
    <section id="solucoes" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
              <i className="ri-apps-2-line" aria-hidden="true"></i>
              Nossas soluções
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              Tudo o que sua empresa precisa para crescer na internet.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Da hospedagem ao servidor, do domínio ao site profissional: encontre em um só lugar a
              infraestrutura e as soluções necessárias para construir e manter sua presença digital.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <Reveal key={service.title} delay={index * 70}>
              <article className="group flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300 hover:bg-background-100/60">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${service.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
                  {service.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {service.description}
                </p>
                <Link
                  to={service.href}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
                >
                  {service.cta}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                </Link>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-12 flex justify-center">
            <Link
              to="/solucoes"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              Ver todas as soluções digitais
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}